import { render, staticRenderFns } from "./unternehmen.vue?vue&type=template&id=0de5b854&"
import script from "./unternehmen.vue?vue&type=script&lang=js&"
export * from "./unternehmen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports